/*
 * Tupaia
 * Copyright (c) 2017 - 2020 Beyond Essential Systems Pty Ltd
 */
import { useMutation } from "react-query";
import { get } from "./api";

const getSearchStatus = (query) => {
  const { status, data, error } = query;

  if (status === "loading") {
    return "isLoading";
  }

  if (error) {
    return "isError";
  }

  if (status === "success" && data?.data?.length === 0) {
    return "areNoResults";
  }

  if (status === "success" && data?.data?.length > 0) {
    return "isSuccess";
  }

  return "isIdle";
};

const processData = (query) => {
  return query?.data?.data;
};

export const useLabResults = () => {
  const query = useMutation("results", (searchValue) =>
    get(`labResultWidget/${searchValue}`)
  );

  const status = getSearchStatus(query);
  const data = processData(query);

  return { ...query, status, data };
};
